<template>
  <layout-default>
    <v-layout wrap align-center justify-center>
      <v-flex xs12 md6>
        <form>
          <v-card style="max-width: 800px">
            <v-card-title
                class="headline font-weight-regular blue-grey white--text"
            >Set user password
            </v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="password"
                  id="password"
                  prepend-icon="fa-key"
                  name="password"
                  label="Password"
                  type="password"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" :loading="loading" @click="setUserPassword">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
        <v-alert v-if="lastError" :value="true" color="error" icon="fa-error">{{
            lastError
          }}</v-alert>
      </v-flex>
    </v-layout>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default.vue";
import SET_USER_PASSWORD_MUTATION from "@/graphql/mutation/SetUserPasswordMutation.gql";

export default {
  data: () => {
    return {
      password: null,
      lastError: null,
      hasErrors: false,
      loading: false,
    };
  },
  components: {
    LayoutDefault,
  },
  methods: {
    async setUserPassword() {
      const variables = {
        userId: this.$route.params.userId,
        newPassword: this.password,
      };
      this.loading = true;
      
      this.$apollo
          .mutate({
            mutation: SET_USER_PASSWORD_MUTATION,
            variables,
            update: async (store, { errors }) => {
              this.loading = false;
              if (errors) {
                return;
              }
              this.$router.push({ name: "usersList" });
            },
          })
          .catch((error) => {
            this.hasErrors = true;
            this.loading = false;
            this.lastError = error;
          });
    },
  },
};
</script>
<style lang="stylus" scoped></style>
